import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { ReactComponent as Download } from '../../res/download.svg';
import PdfLoader from '../../utils/PdfLoader';
import ButtonWithIcon from '../../components/ButtonWithIcon';

import styles from './styles';

class B30Thanks extends React.Component {
  renderBackground() {
    const { classes } = this.props;
    return <div className={classes.background}></div>;
  }

  renderContent() {
    const { classes, data, baseUrl } = this.props;
    const baseUrlBlocks = `${baseUrl}/blocks/`;
    // const mainTitle = parse(data.blocks.b30thanks.mainTitle);

    return (
      <div className={classes.content}>
        <img src={`${baseUrlBlocks}${data.blocks.b30thanks.imgLogoSrc}`} alt="" className={classes.logo} />
        <div className={classes.desc}>
          {/* <Typography variant="h1" className={classes.mainTitle}>
            {mainTitle}
          </Typography> */}
          <div>
            <Typography variant="h5" className={classes.titles}>
              {parse(data.blocks.b30thanks.whatTitle)}
            </Typography>
            <Typography variant="body1">{parse(data.blocks.b30thanks.what)}</Typography>
          </div>
          <div>
            <Typography variant="h5" className={classes.titles}>
              {parse(data.blocks.b30thanks.imgCreditTitle)}
            </Typography>
            <Typography variant="body1">{parse(data.blocks.b30thanks.imgCredit)}</Typography>
          </div>
          <div>
            <Typography variant="h5" className={classes.titles}>
              {parse(data.blocks.b30thanks.designCreditTitle)}
            </Typography>
            <Typography variant="body2">{parse(data.blocks.b30thanks.designCredit)}</Typography>
          </div>
        </div>
        <div className={classes.btn}>
          <ButtonWithIcon
            onClick={PdfLoader(data.blocks.b30thanks.pdf)}
            color="black"
            icon={<Download />}
            iconPosition="top"
          >
            {parse(data.blocks.b30thanks.downloadBtn)}
          </ButtonWithIcon>
        </div>
      </div>
    );
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.blockContainer}>
        {this.renderBackground()}
        {this.renderContent()}
      </div>
    );
  }
}

B30Thanks.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object,
  baseUrl: PropTypes.string,
};

export default withStyles(styles)(B30Thanks);
